module.exports = __webpack_public_path__ + "img/Taiwan.3cceb462.svg";